import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouteError } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { Flex, Grid } from 'shared/grid';
import { CroppedText, Link } from 'shared/typography';
import Button from 'shared/button';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { Layout } from '../layout';

export default function ErrorPage() {
  const error = useRouteError() as any;
  // console.error(error);

  //   return (
  //     <div id="error-page">
  //       <h1>Oops!</h1>
  //       <p>Sorry, an unexpected error has occurred.</p>
  //       <p>
  //         <i>{error.statusText || error.message}</i>
  //       </p>
  //     </div>
  //   );

  return (
    <Layout>
      <Flex justifyContent="center" alignItems="center" flex={1} height="100vh">
        {error?.status === 404 ? (
          <Grid textAlign="center" justifyItems="center">
            <CroppedText
              mx="auto"
              mb={8}
              fontSize={['60px', '120px', '180px']}
              color="gray.1"
              fontWeight="700"
            >
              404
            </CroppedText>
            <CroppedText
              as="h1"
              fontSize={[4, 5, 6]}
              color="text"
              fontWeight="bold"
              mb={4}
            >
              <FormattedMessage
                defaultMessage="Page not found"
                description="Error page title when a 404 not found error occurs"
              />
            </CroppedText>
            <Button as="a" href="/">
              <FormattedMessage
                defaultMessage="Take me back"
                description="Link label that navigates user back from error page"
              />
            </Button>
          </Grid>
        ) : (
          <Grid textAlign="center">
            <CroppedText as="h1" fontSize={6} color="text">
              <FormattedMessage
                defaultMessage="Something went wrong"
                description="Generic error page title for unexpected errors"
              />
              : {error?.status || ''} {error?.statusText || ''}
            </CroppedText>
            <Link variant="discreetLink" href="/">
              <FontAwesomeIcon icon={faChevronLeft} />{' '}
              <FormattedMessage
                defaultMessage="Take me back"
                description="Link label that navigates user back from error page"
              />
            </Link>
          </Grid>
        )}
      </Flex>
    </Layout>
  );
}
